import {  
  SET_ADDING_LOGO,
  SAVE_LOGO_SUCCESS,
  SAVE_LOGO_FAILED,
  GET_LOGO_SUCCESS,
  DELETE_LOGO_SUCCESS,
  DELETE_LOGO_FAILED,  
  INVALID_LOGO,
  CLOSE_LOGO_SNACKBAR,
  CLEAR_SELECTED_USER  
} from '../constants'

const initialState = {  
  logo: null,
  logoSaved: false,
  logoSaveFailed: false,
  addingLogo: false,
  deleteLogoSuccess: false,
  deleteLogoFailed: false,
  isInvalidLogo: false,
  isCorruptLogo: false 
}

const logoReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_ADDING_LOGO:
      return Object.assign(
        {},
        { ...state },
        {
          logoSaved: false,
          addingLogo: action.addingLogo,
          logo: null
        }
      )

    case SAVE_LOGO_SUCCESS:
      return Object.assign(
        {},
        { ...state },
        {
          logoSaved: true,
          addingLogo: false,
          logo: action.data
        }
      )

    case SAVE_LOGO_FAILED:
      return Object.assign(
        {},
        { ...state },
        {
          logoSaved: false,
          logoSaveFailed: true
        }
      )

    case GET_LOGO_SUCCESS:
      return Object.assign(
        {},
        { ...state },
        {
          logo: action.logo,
          addingLogo: false
        }
      )

    case DELETE_LOGO_SUCCESS:
      return Object.assign(
        {},
        { ...state },
        {
          deleteLogoSuccess: true,
          addingLogo: false,
          logo: null
        }
      )

    case DELETE_LOGO_FAILED:
      return Object.assign(
        {},
        { ...state },
        {
          deleteLogoFailed: true,
          addingLogo: false,
          logo: null
        }
      )

    case INVALID_LOGO:
      if (action.error === 'format') {
        return Object.assign(
          {},
          { ...state },
          {
            isInvalidLogo: true,
            logo: null
          }
        )
      }
      if (action.error === 'corrupt') {
        return Object.assign(
          {},
          { ...state },
          {
            isCorruptLogo: true,
            logo: null
          }
        )
      }

    case CLOSE_LOGO_SNACKBAR:
      return Object.assign({}, state, {
        logoSaved: false,
        logoSaveFailed: false,
        deleteLogoSuccess: false,
        deleteLogoFailed: false,
        isInvalidLogo: false,
        isCorruptLogo: false
      })

    case CLEAR_SELECTED_USER:
      return Object.assign(
        {},
        { ...state },
        {
          logo: null
        }
      )

    default:
      return state
  }
}

export default logoReducer